import type { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { Badge } from '../Badge/Badge';

import * as styles from './AdBadge.module.scss';

export const AdBadge: FC = () => {
  const { t } = useTranslation();

  return <Badge label={t('advertisement')} className={styles.badge} />;
};
